import React from 'react';
import { Input, Button, Select, PaperClip, Table, Tooltip } from 'components';
import { PackageService } from 'services';
import { Globals, Constants } from 'utils';
import { AddImage } from 'assets/img';
import { TrashIcon, CheckWhiteIcon } from 'assets/icons';
import { PackageServiceItem, PackageImage } from 'types';

interface Props {
  onClose?: any;
  item?: any;
}

const DURATION_UNITS = [
  { value: 'days', label: 'Días' },
  { value: 'months', label: 'Meses' },
];

class CreatePackage extends React.Component<Props> {
  state = {
    form: {
      name: '',
      price: '',
      duration_value: '',
      duration_unit: 'days',
      image: '' as string | PackageImage,
      level_id: '',
    },
    services: [] as PackageServiceItem[],
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const res: any = await PackageService.admin.getServices({
      package_id: this.props.item?.id,
    });

    this.setState(
      {
        services:
          res.services.map((i: any) => {
            i.active = false;
            i.uses = 0;
            i.unlimited = false;
            i.marketplace = false;

            const item = res.package?.package_services.find((item: any) => item.service_id == i.id);

            if (item) {
              i.active = true;
              i.uses = item.uses || 0;
              i.unlimited = item.unlimited == 1;
              i.marketplace = !!item.marketplace;
            }

            return i;
          }) || [],
      },
      () => {
        if (this.props.item) {
          this.setState({
            form: {
              ...this.state.form,
              name: this.props.item?.name || '',
              price: this.props.item?.price || '',
              duration_value: this.props.item?.duration_value || '',
              duration_unit: this.props.item?.duration_unit || 'days',
              level_id: this.props.item?.level_id || '',
            },
          });
        }
      },
    );
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  setLevel = (level_id: number) => {
    this.setState({
      form: {
        ...this.state.form,
        level_id,
      },
    });
  };

  submit = async (e: any) => {
    e.preventDefault();

    const activeServices = this.state.services.filter((i: any) => i.active);

    const missingUses = activeServices.filter((i: any) => !i.unlimited && !i.uses);

    if (missingUses.length > 0) {
      Globals.showError('Debe ingresar los usos de cada servicio asignado');
      return;
    }

    const invalidUses = activeServices.filter(
      (i: any) => !i.unlimited && !Globals.isValidIntegerString(String(i.uses)),
    );

    if (invalidUses.length > 0) {
      Globals.showError('Los usos deben ser números');
      return;
    }

    if (!this.state.form.name) {
      Globals.showError('Debe ingresar un nombre');
      return;
    }

    if (!this.state.form.level_id) {
      Globals.showError('Debe seleccionar un tipo de usuario');
      return;
    }

    if (!this.state.form.price || parseFloat(this.state.form.price as any) <= 0) {
      Globals.showError('El precio debe ser mayor a 0');
      return;
    }

    if (
      !Globals.isValidIntegerString(String(this.state.form.duration_value)) ||
      parseInt(this.state.form.duration_value as any) <= 0
    ) {
      Globals.showError('La duración debe ser un número mayor a 0');
      return;
    }

    const payload = {
      ...this.state.form,
      hasFile: true,
      image: (this.state.form.image as PackageImage)?.value || '',
      services: JSON.stringify(activeServices),
    };

    if (this.props.item != null) {
      await PackageService.admin.update({
        package_id: this.props.item?.id,
        ...payload,
      });
      Globals.showSuccess('Se ha modificado el paquete correctamente');
    } else {
      await PackageService.admin.create(payload);
      Globals.showSuccess('Se ha creado el paquete correctamente');
    }

    this.props.onClose();
  };

  render() {
    const activeServices = this.state.services.filter((i: any) => i.active && !i.without_quantity);
    const availableServices = this.state.services.filter(
      (i: any) => !i.active && !i.without_quantity,
    );
    const enableServices = this.state.services.filter((i: any) => i.without_quantity);

    return (
      <div id='modal-create-package'>
        <form onSubmit={this.submit}>
          <div className='container-inputs'>
            <div className='row'>
              <div className='col-md-12'>
                <div className='image-selector'>
                  <PaperClip
                    formats={['png', 'jpg', 'jpeg']}
                    value={this.state.form.image}
                    width={1080}
                    height={1080}
                    onChange={(e: any) => {
                      this.setState({
                        form: {
                          ...this.state.form,
                          image: e.target,
                        },
                      });
                    }}
                  >
                    <div className='container-image'>
                      <img
                        src={
                          (this.state.form.image as PackageImage)?.dataURL ||
                          (this.props.item?.image &&
                            Constants.BASE_STORAGE + this.props.item?.image) ||
                          AddImage
                        }
                        className={!this.state.form.image && !this.props.item?.image ? 'empty' : ''}
                      />
                    </div>
                  </PaperClip>
                  <div className='container-text'>
                    <p className='bold'>Subir imagen</p>
                    <p>Imagen PNG o JPG máximo 1080px por 1080px (opcional)</p>
                  </div>
                </div>
              </div>
              <div className='col-md-12'>
                <Input
                  color='white'
                  value={this.state.form.name}
                  name='name'
                  label='Nombre'
                  onChange={this.change}
                />
              </div>
            </div>
          </div>
          <div className='container-leaf'>
            <label>Seleccionar usuario</label>
            <div className='row'>
              <div className='col-md-6'>
                <div
                  className='level-container'
                  onClick={() => this.setLevel(Constants.LEVELS.CLIENT)}
                >
                  <div
                    className={`check-level ${parseInt(this.state.form.level_id as any) == Constants.LEVELS.CLIENT ? 'active' : ''}`}
                  ></div>
                  <p>Cliente</p>
                </div>
              </div>
              <div className='col-md-6'>
                <div
                  className='level-container'
                  onClick={() => this.setLevel(Constants.LEVELS.LAWYER)}
                >
                  <div
                    className={`check-level ${parseInt(this.state.form.level_id as any) == Constants.LEVELS.LAWYER ? 'active' : ''}`}
                  ></div>
                  <p>Abogado</p>
                </div>
              </div>
            </div>
            <hr />
            <label>Precio y duración</label>
            <div className='row'>
              <div className='col-md-6'>
                <Input
                  type='decimal'
                  color='white'
                  value={this.state.form.price}
                  name='price'
                  label='Precio'
                  placeholder='0.00'
                  className='price-input'
                  onChange={this.change}
                />
              </div>
              <div className='col-md-3'>
                <Input
                  type='number'
                  color='white'
                  value={this.state.form.duration_value}
                  name='duration_value'
                  label='Duración'
                  placeholder='30'
                  onChange={this.change}
                />
              </div>
              <div className='col-md-3'>
                <Select
                  color='white'
                  label='Unidad'
                  name='duration_unit'
                  onChange={this.change}
                  value={this.state.form.duration_unit}
                  options={DURATION_UNITS}
                />
              </div>
            </div>
          </div>
          <div className='container-inputs'>
            <Select
              color='white'
              placeholder='Seleccionar'
              label='Servicios'
              name='service_id'
              onChange={(e: any) => {
                const service_id = e.target.value;
                let services = [...this.state.services];
                const index = services.findIndex((i: any) => i.id == service_id);
                services[index].active = true;
                this.setState({ services });
              }}
              value=''
              options={availableServices.map((item: any) => {
                return { value: item.id, label: item.name };
              })}
            />
            <Table
              showAlwaysHeader={true}
              rightAlign={[1]}
              noItemsMessage='No ha añadido servicios'
              data={activeServices}
              header={['Servicios', 'Cant. de uso']}
            >
              {activeServices.map((item: PackageServiceItem) => {
                return (
                  <tr>
                    <td>
                      <p className='service-name'>{item.name}</p>
                    </td>
                    <td className='text-right'>
                      <div className='container-uses'>
                        <div
                          className='level-container'
                          onClick={() => {
                            let services = [...this.state.services];
                            const index = services.findIndex((i) => i.id == item.id);
                            services[index].unlimited = !services[index].unlimited;
                            services[index].uses = 0;
                            this.setState({ services });
                          }}
                        >
                          <div className={`check-level ${item.unlimited ? 'active' : ''}`}></div>
                          <p>Ilimitado</p>
                        </div>
                        {!item.unlimited && (
                          <Input
                            color='white'
                            value={item.uses}
                            name='uses'
                            placeholder='0'
                            className='input-uses'
                            onChange={(e: any) => {
                              let services = [...this.state.services];
                              const index = services.findIndex((i) => i.id == item.id);
                              services[index].uses = e.target.value;
                              this.setState({ services });
                            }}
                          />
                        )}
                        <Tooltip title='Eliminar'>
                          <a
                            className='link-icon'
                            href='#'
                            onClick={(e: any) => {
                              e.preventDefault();
                              let services = [...this.state.services];
                              const index = services.findIndex((i) => i.id == item.id);
                              services[index].active = false;
                              this.setState({ services });
                            }}
                          >
                            <img src={TrashIcon} />
                          </a>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </Table>
            {enableServices.length > 0 && (
              <>
                <hr />
                <p className='label'>Habilitación de servicios</p>
                {enableServices.map((item: any) => {
                  return (
                    <div
                      className='container-check'
                      onClick={() => {
                        let services = [...this.state.services];
                        const index = services.findIndex((i: any) => i.id == item.id);
                        services[index].active = !services[index].active;
                        services[index].unlimited = true;
                        services[index].uses = 0;
                        this.setState({ services });
                      }}
                    >
                      <div className={`check ${item.active ? 'active' : ''}`}>
                        {item.active && <img src={CheckWhiteIcon} />}
                      </div>
                      <p>{item.name}</p>
                    </div>
                  );
                })}
              </>
            )}
          </div>
          <div className='text-center'>
            <Button type='submit'>Guardar</Button>
          </div>
        </form>
      </div>
    );
  }
}

export default CreatePackage;
